export const azureADConfigsDEV = {
        clientId: "f3ce25bd-74ae-43bd-910a-b7f80244da02",
        tenantId: "dc05c43c-39ce-4caa-8a98-891c451b96f0",
        authority: "https://M1T4CAIT.b2clogin.com/M1T4CAIT.onmicrosoft.com/B2C_1_cnaSigninFlow",
        knownAuthorities: ["M1T4CAIT.b2clogin.com"]
}

export const azureADConfigsTEST = {
        clientId: "",
        tenantId: "",
        authority: "",
        knownAuthorities: [""]
}


export const azureADConfigsPROD = {
        clientId: "b7a5e0d0-bfd1-4282-85eb-c97a55a9eb66",
        tenantId: "c3bf967d-935d-468b-8aa0-026815806c43",
        authority: "https://CNA4Cait.b2clogin.com/CNA4Cait.onmicrosoft.com/B2C_1_cnaSigninFlow",
        knownAuthorities: ["CNA4Cait.b2clogin.com"]
}


export const tokenClaimScope = {
        devEnvScope: ["https://M1T4CAIT.onmicrosoft.com/f3ce25bd-74ae-43bd-910a-b7f80244da02/Cna.Api"],
        testEnvScope: [""],
        prodEnvScop: ["https://CNA4Cait.onmicrosoft.com/b7a5e0d0-bfd1-4282-85eb-c97a55a9eb66/Cna.Api"]
}
        
